import { AuthInfo } from '../../../models/apiModels';
import { ClientAuthProvider } from '../../../utilities';
import { HelpPaneServices } from './helpPaneServices';

export const macHelpPaneServices = (logClientDebuggingEvent: (
    behavior: number,
    formName: string,
    contentName: string,
    areaName: string,
    fileName: string,
    functionName: string,
    loggingArea: string,
    message: string) => void): HelpPaneServices => {
    const macTokenDebugEvent = (functionName: string, loggingArea: string, message: string): void => {
        logClientDebuggingEvent(
            300,
            'maxFunnel',
            'signInButton',
            'modalitiesSection',
            'macHelpPaneServices.ts',
            functionName,
            loggingArea,
            message
        );
    };

    const parseProvider = (token: string): string => token.toLowerCase().indexOf('passport') > -1 ? ClientAuthProvider.MSA : ClientAuthProvider.AAD;

    const getClientToken = (
        clientWindow: any): Promise<AuthInfo> => {
        macTokenDebugEvent(
            'getClientToken',
            'clientLogin',
            `Call mac sign in handler`
        );

        const promise = new Promise<AuthInfo>((resolve, reject) => {
            try {
                if (!clientWindow || !clientWindow.WebViewJavascriptBridge) {
                    reject({
                        status: 'Mac Bridge is undefined.',
                    });
                }

                clientWindow.WebViewJavascriptBridge.callHandler('signInCallback', {}, function (response: any) {
                    const callbackResponse = JSON.parse(response);
                    if (callbackResponse.success) {
                        macTokenDebugEvent(
                            'getClientToken',
                            'clientLogin',
                            `Mac sign in handler success`
                        );
                        resolve({
                            provider: parseProvider(callbackResponse.tokenValue),
                            token: callbackResponse.tokenValue,
                        });
                    } else {
                        macTokenDebugEvent(
                            'getClientToken',
                            'clientLogin',
                            `Mac sign in handler failure`
                        );
                        reject({
                            status: `Mac client login failure: {response.success}.`,
                        });
                    }
                });
            } catch (e) {
                const exceptionDetail = JSON.stringify(e);
                macTokenDebugEvent(
                    'getClientToken',
                    'clientLoginError',
                    `Mac sign exception in promise creation: ${exceptionDetail}`
                );
                reject({
                    status: 'Error on callback.',
                });
            }
        });

        return promise;
    };

    return {
        getClientToken: getClientToken,
    };
};
